module.exports = __webpack_public_path__ + "img/crime.5a8872f3.svg";